import React, { useEffect, useState } from "react";
import "../styles/GlobalSearch.css";
import { globalSearch } from "../service/globalSearch.service";
import { useNavigate } from "react-router-dom";

function GlobalSearch() {
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const [suggestions, setSuggestions] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const navigate = useNavigate();

  const handleOpen = () => {
    setShowModal(true);
    setSearch("");
    setSuggestions([]);
    setActiveIndex(-1);
  };

  const handleClose = () => {
    setShowModal(false);
    setSearch("");
    setSuggestions([]);
    setActiveIndex(-1);
  };

const handleSuggestionClick = (item) => {
  if (!item) {
    return;
  }
const keyword = search.trim();

  if (!keyword) {
    return;
  }
  setShowModal(false);
  setSearch("");
  setSuggestions([]);
  setActiveIndex(-1);

  const qualitySlug =
    item?.quality_slug
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-");
  navigate(
    `/search?q=${keyword}&sourceQuery=${qualitySlug}`
  );
};

  useEffect(() => {
    const keyword = search.trim();

    if (!keyword) {
      setSuggestions([]);
      setSearchLoading(false);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        setSearchLoading(true);
        const response = await globalSearch(keyword);
        const results = response?.data?.items || [];
        setSuggestions(
          Array.isArray(results) ? results : []
        );

        setActiveIndex(-1);
      } catch (error) {
        console.error("Global Search Error:", error);

        setSuggestions([]);
        setActiveIndex(-1);
      } finally {
        setSearchLoading(false);
      }
    }, 350);

    return () => clearTimeout(timer);
  }, [search]);

const handleSearchNavigate = () => {
  const keyword = search.trim();

  if (!keyword) {
    return;
  }

  setShowModal(false);
  setSearch("");
  setSuggestions([]);
  setActiveIndex(-1);

  navigate(
    `/search?q=${encodeURIComponent(keyword)}`
  );
};
const handleKeyDown = (e) => {
  if (e.key === "Escape") {
    handleClose();
    return;
  }

  if (!suggestions.length) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchNavigate();
    }
    return;
  }

  if (e.key === "ArrowDown") {
    e.preventDefault();

    setActiveIndex((prev) => {
      const nextIndex =
        prev < suggestions.length - 1 ? prev + 1 : 0;

      return nextIndex;
    });

    return;
  }

  if (e.key === "ArrowUp") {
    e.preventDefault();

    setActiveIndex((prev) => {
      const nextIndex =
        prev > 0 ? prev - 1 : suggestions.length - 1;

      return nextIndex;
    });

    return;
  }

  if (e.key === "Enter") {
    e.preventDefault();

    if (activeIndex >= 0 && suggestions[activeIndex]) {
      handleSuggestionClick(suggestions[activeIndex]);
      return;
    }

    handleSearchNavigate();
  }
};

  const highlightText = (text = "") => {
    if (!search.trim() || !text) {
      return text;
    }

    const escapedSearch = search.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );

    const regex = new RegExp(
      `(${escapedSearch})`,
      "gi"
    );

    const parts = String(text).split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <mark key={index}>{part}</mark>
      ) : (
        part
      )
    );
  };

  return (
    <>
      {/* SEARCH ICON */}
      <div
        className="global-search-trigger"
        style={{
          marginTop: "1px",
          marginLeft: "0",
        }}
      >
       <button
          type="button"
          className="global-search-button"
          onClick={handleOpen}
          aria-label="Open search"
        >
          <i
            className="bi bi-search search-icon2"
            aria-hidden="true"
          ></i>
        </button>
      </div>

      {/* SEARCH MODAL */}
      {showModal && (
        <div
          className="global-search-modal-backdrop"
          onClick={handleClose}
        >
          <div
            className="global-search-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* SEARCH INPUT ONLY */}
            <div className="global-search-input-wrapper">
              <i className="bi bi-search global-search-input-icon"></i>

              <input
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setActiveIndex(-1);
                }}
                onKeyDown={handleKeyDown}
                placeholder="Search quality, design, shade..."
                autoFocus
                autoComplete="off"
              />

              {searchLoading && (
                <span className="global-search-loader">
                  <span className="search-spinner"></span>
                </span>
              )}

              {!searchLoading && search && (
                <button
                  type="button"
                  className="global-search-clear"
                  onClick={() => {
                    setSearch("");
                    setSuggestions([]);
                    setActiveIndex(-1);
                  }}
                  aria-label="Clear search"
                >
                  <i className="bi bi-x-circle-fill"></i>
                </button>
              )}

              {/* AUTOCOMPLETE */}
              {search.trim() && (
                <div className="global-search-autocomplete">
                  {searchLoading ? (
                    <div className="autocomplete-loading">
                      <span className="search-spinner"></span>
                      <span>Searching...</span>
                    </div>
                  ) : suggestions.length > 0 ? (
                    <div className="autocomplete-list">
                      {suggestions.map((item, index) => {
                        const image =
                          item?.design_shade_image_path ||
                          item?.quality_image_path;

                        return (
                          <button
                            type="button"
                            key={`${item?.qualityName}-${item?.design}-${item?.shade}-${index}`}
                            className={`autocomplete-item ${
                              activeIndex === index
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              handleSuggestionClick(item)
                            }
                            onMouseEnter={() =>
                              setActiveIndex(index)
                            }
                          >
                            {/* IMAGE */}
                            <div className="autocomplete-image">
                              {image ? (
                                <img
                                  src={image}
                                  alt={`${item?.qualityName} ${item?.design} ${item?.shade}`}
                                  onError={(e) => {
                                    e.currentTarget.style.display =
                                      "none";

                                    e.currentTarget.parentElement.classList.add(
                                      "image-error"
                                    );
                                  }}
                                />
                              ) : (
                                <i className="bi bi-image"></i>
                              )}
                            </div>

                            {/* CONTENT */}
                            <div className="autocomplete-content">
                              <strong className="autocomplete-quality">
                                {highlightText(
                                  item?.qualityName
                                )}
                              </strong>

                              <div className="autocomplete-design-shade">
                                <span className="design-value">
                                  {highlightText(
                                    item?.name
                                  )}
                                </span>

                                <span className="design-value" style={{fontWeight:"bold"}}>
                                  {highlightText(
                                    item?.design
                                  )}
                                </span>
                                <span
                                  className="shade-value"
                                  style={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  {highlightText(
                                    item?.shade
                                  )}
                                </span>
                              </div>
                            </div>

                            {/* ARROW */}
                            <i className="bi bi-arrow-up-right autocomplete-arrow"></i>
                          </button>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="autocomplete-no-results">
                      <div className="autocomplete-no-icon">
                        <i className="bi bi-search"></i>
                      </div>

                      <strong>
                        No suggestions found
                      </strong>

                      <span>
                        Try another quality, design or
                        shade
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default GlobalSearch;